import { Component, Inject } from '@angular/core';
import { UserPromptService } from '../services/user-prompt.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatRadioGroup, MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { DashboardService } from '../services/shared/dashboard.service';
import { Router } from '@angular/router';
import { RejectSuccessComponent } from '../reject-success/reject-success.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from '../components/common/components/snack-bar/snack-bar.component';
import { ErrorNotficationComponent } from '../error-notfication/error-notfication.component';

@Component({
  selector: 'app-reject-prompt',
  standalone: true,
  imports: [MatDialogModule, CommonModule, FormsModule, MatRadioGroup,MatRadioModule],
  templateUrl: './reject-prompt.component.html',
  styleUrl: './reject-prompt.component.scss'
})
export class RejectPromptComponent {
  message: string = ""
  title: string = ""
  action: string = ""
  actionType: string = "add"
  cancelButtonText = "Cancel"
  promptUserDetails: any;
  isSubmitDisabled:boolean = false;
  isCommentRequired:boolean = false;
  comments: string ='';
  selectedrating: any;
  selectedRadio:any;
  showCommentsError:boolean= false;
  user_role: any;
  userid: any;
promptDetailsChainData: {
  prompt_detail_id: any;
  prompt_name: any;
  prompt: any;
  model_id: any;
  order_number: any;
  attachments: any;
  variables: any; 
  }[] = [];
  is_chain:boolean=false;

  constructor(private snackBar: MatSnackBar, 
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<RejectPromptComponent>,private userPromptService: UserPromptService, private dialog: MatDialog, private dashboardService : DashboardService, private router : Router) {
    if (data) {
     this.promptUserDetails = data;
     if(this.promptUserDetails.prompt_type == 'chain' ){
      this.is_chain=true;
     }
    }
     this.dialogRef.updateSize('200vw', '90vh')
  } 

  async ngOnInit() {
    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;
  }
  
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  onRadioButtonChange(event:any){
this.selectedRadio = event?.value
  }

  selectComment(others:any){
    this.selectedrating = others;
    if(others){
      this.isCommentRequired = true;
    }else{
      this.isCommentRequired = false;
      this.isSubmitDisabled = false;
    }
   
  } 

  enterComments(event: any) {
    if (event !== null || event !== undefined || event !== '' ) {
      this.showCommentsError = false;
    }
    if(event.length>0){
      this.isSubmitDisabled=false;
    }else{
      this.isSubmitDisabled=true;
    }
  }

  openSnackbar(message: string, title: string, cssClass: string) {
        // this.snackBar.openFromComponent(SnackBarComponent, {
        //   data: { message: message, type: type },
        //   duration: 3000, // Duration in milliseconds,
        //   horizontalPosition: 'center',
        //   verticalPosition: 'top',
        //   panelClass: [cssClass],
        // });
         const dialogRef = this.dialog.open(ErrorNotficationComponent, {
                       data: {
                         message: message,
                         title: title,
                         action_type: 'add'
                       }
                     });
      }

  onReject() { 
     let reason=''; 
    // if(this.selectedRadio){
    //   reason=this.selectedRadio;
    // }
    // this.selectedRadio === 'others' &&

    if ( this.comments.length <= 0) {
      this.showCommentsError = true;

      return;
    }

    reason = this.comments;
    // }else if(!this.selectedRadio ){
    //   this.openSnackbar("Can't Reject. please provide some reason for reject.", 'Error Message', 'error-snackbar')
    //   return;
    // }  

    // if(this.selectedRadio === 'others'){
    //   reason = this.comments;
    // }

    this.promptUserDetails.prompt_details.forEach((data: any ) => {
      this.promptDetailsChainData.push({
        "prompt_detail_id":data?.prompt_detail_id,
        "prompt_name": data?.prompt_name,
        "prompt":  data?.prompt,
        "model_id":  data?.llm?.model_id ?? null,
        "order_number":  data.order_number,
        "attachments":  data.attachments,
        "variables": data.variables,
      })
      
    });
   let request = {
      "prompt": {
        "prompt_id": this.promptUserDetails?.prompt_id,
        "title": this.promptUserDetails?.title,
        "description": this.promptUserDetails?.description,
        "notes":this.promptUserDetails?.notes,
        "category_id": this.promptUserDetails.category?.category_id,
        "created_by": this.promptUserDetails?.created_by?.created_by ,
        "sub_category_id": this.promptUserDetails?.sub_category?.sub_category_id ?  this.promptUserDetails?.sub_category?.sub_category_id : null,
        "prompt_type":this.promptUserDetails.prompt_type,
        "prompt_details": this.promptDetailsChainData
      },
      "rejection_reason": reason,
      "status": "REJECTED",
      "user_id": +this.userid
    }

    let messageData='';
      const variant = this.promptUserDetails?.variant;
      const version = this.promptUserDetails?.version;
      const promptTitle = this.promptUserDetails?.title;
      let promptDetailsData=this.promptUserDetails?.prompt_details;
      if (promptDetailsData && promptDetailsData.length > 1) {
        // messageData = `The prompt chain '${this.promptUserDetails?.title}' has been approved and published successfully`
        messageData = `The prompt chain `;
        if ((variant >= 1) && (version >= 1)) {
          messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
        } else if ((variant >= 1) && (version < 1)) {
          messageData += `'${promptTitle} - Variant ${variant}'`;
        } else if ((version >= 1 && (variant < 1))) {
          messageData += `'${promptTitle} - Version ${version}'`;
        } else {
          messageData += `'${promptTitle}'`;
        }
        messageData += ' has been rejected successfully';
        this.message=messageData;
      } else if(promptDetailsData && promptDetailsData.length == 1) {
        // messageData = `The prompt '${this.promptUserDetails?.title}' has been approved and published successfully`
        messageData = `The prompt `;
        if ((variant >= 1) && (version >= 1)) {
          messageData += `'${promptTitle} - Variant ${variant} Version ${version}'`;
        } else if ((variant >= 1) && (version < 1)) {
          messageData += `'${promptTitle} - Variant ${variant}'`;
        } else if ((version >= 1 && (variant < 1))) {
          messageData += `'${promptTitle} - Version ${version}'`;
        } else {
          messageData += `'${promptTitle}'`;
        }
        messageData += ' has been rejected successfully';
        this.message=messageData;
      }
    this.userPromptService.approvePrompt(request).subscribe(res => {
      const dialogRef = this.dialog.open(RejectSuccessComponent, {
        data: {
          message: this.message,
          title: 'Rejected Successfully',
          action_type: 'add',

        }
      });
    });
    this.dialogRef.close(true);
    this.router.navigateByUrl('/home/dashboard');
  }
  // else{
  //   this.showCommentsError = false;
  // }
}
